<template>
  <div>
    <v-row>
      <v-col cols=12>
        <h1>Notifications</h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols=12>
        <v-card elevation=0 class="pa-4" style="">
          <v-row>

            <v-col cols="12" sm="10" offset-sm="1" md="8" offset-md="2" class="d-flex justify-center align-center flex-column">
              <div class="" style="width: 100%;">
                <v-switch label="Email notifications" />
                <v-switch label="Email notifications" />
                <v-switch label="Email notifications" />

                <v-btn color="primary" elevation="0" block>
                  Save
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <!-- <v-row>
      <v-col cols=12>
        <h1>Notifications</h1>
      </v-col>
    </v-row> -->


  </div>
</template>

<script>
export default {
  name: "ProfileNotifications",
}
</script>
